<template>
	<div class="index-wrap">
		<div class="flex flex-row-between index-top-wrap">
			<el-carousel>
				<el-carousel-item v-for="item in slide" :key="item.news_id">
					<el-image :src="item.image" srcset="">
						<div slot="placeholder" class="image-slot"></div>
					</el-image>
					<div class="">
						<h3 class="ellipsis-1">{{ item.title }}</h3>
					</div>
				</el-carousel-item>
			</el-carousel>

			<div class="index-top">
				<div class="flex flex-row-between index-top-nav">
					<div :class="{ active: topNav === '头条资讯' }" @click="topNavChange('头条资讯')">头条资讯</div>
					<div :class="{ active: topNav === '肥城动态' }" @click="topNavChange('肥城动态')">肥城动态</div>
					<div :class="{ active: topNav === '国内动态' }" @click="topNavChange('国内动态')">国内动态</div>
				</div>
				<transition name="topList" :key="topNav">
					<div class="wrap-border index-top-list">
						<div class="index-top-more" @click="goMoreHandler">更多</div>
						<ul>
							<li class="" v-for="(item, index) in currentTrends" :key="index">
								<router-link class="index-top-top" v-if="index < 1" :to="`/common/article/1/${item.id}`">
									<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
									<p>{{ item.description | sliceBrief }}<span v-if="item.description">查看更多</span></p>
								</router-link>
								<router-link class="index-top-flex" v-else :to="`/common/article/1/${item.id}`">
									<div class="flex flex-row-between">
										<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
										<p>{{ item.publishtime }}</p>
									</div>
								</router-link>
							</li>
						</ul>
					</div>
				</transition>
			</div>
		</div>
		<div class="index-link flex flex-row-between">
      <template v-for="item in TOP">
        <!-- 外部链接使用 a 标签 -->
        <a
            class="index-link-box"
            v-if="item.link.startsWith('http')"
            :key="'ext-' + item.id"
            :href="item.link"
            target="_blank"
        >
          <img :src="item.image" :alt="item.title" srcset="" />
          <p>{{ item.title }}</p>
        </a>
        <!-- 内部链接使用 router-link -->
        <router-link
            class="index-link-box"
            tag="a"
            v-else
            :key="'int-' + item.id"
            :to="item.link"
        >
          <img :src="item.image" :alt="item.title" srcset="" />
          <p>{{ item.title }}</p>
        </router-link>
      </template>
		</div>
		<div class="flex index-column-wrap">
			<!-- <router-link class="fy-rank" tag="a" to="/antiDisease">
				<img src="../static/images/index/fy.png" alt="" />
			</router-link> -->
			<a href="https://credit.shandong.gov.cn/snipet/1028.html" title="无违法违规记录证明" target="_blank" class="fy-rank"> <span><img style="width:100%;height:120px;" border="0" align="center" src="../static/images/index/wfzjl.png"></span></a>
			<!-- 疫情防控======>>>合同履约 -->
			<router-link class="fy-rank" tag="a" to="/contract/contractView">
				<img src="../static/images/index/contract.png" alt="" />
			</router-link>
			<router-link class="fy-rank" tag="a" to="/column">
				<img src="../static/images/celoan.jpg" alt="" />
			</router-link>
		</div>

		<div class="flex flex-wrap index-main">
<!--			<div class="index-main-box">-->
<!--				<div class="flex flex-row-between index-main-top">-->
<!--					<div class="flex">-->
<!--						<i class="iconfont icon-Z-fenleidaohang"></i>-->
<!--						<div class="">信用动态</div>-->
<!--					</div>-->
<!--					<router-link class="index-main-top-more" to="/common/dynamics/国内动态">更多<i class="el-icon-d-arrow-right"></i></router-link>-->
<!--				</div>-->
<!--				<div class="wrap-border">-->
<!--					<empty v-if="!xy_trends.length" :padding="'58px 0'" />-->
<!--					<ul class="index-main-list" v-else>-->
<!--						<li v-for="item in xy_trends" :key="item.id">-->
<!--							<router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/common/article/1/${item.id}`">-->
<!--								<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>-->
<!--								<p>{{ item.publishtime }}</p>-->
<!--							</router-link>-->
<!--						</li>-->
<!--					</ul>-->
<!--				</div>-->
<!--			</div>-->
      <div class="index-main-box">
        <div class="flex flex-row-between index-main-top">
          <div class="flex">
            <i class="iconfont icon-Z-fenleidaohang"></i>
            <div class="">通知公告</div>
          </div>
          <router-link class="index-main-top-more" to="/common/notice">更多<i class="el-icon-d-arrow-right"></i></router-link>
        </div>
        <div class="wrap-border">
          <empty v-if="!tzgg.length" :padding="'58px 0'" />
          <ul class="index-main-list" v-else>
            <li v-for="item in tzgg" :key="item.id">
              <router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/common/article/9/${item.id}`">
                <p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
                <p>{{ item.publishtime }}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
			<div class="index-main-box">
				<div class="flex flex-row-between index-main-top">
					<div class="flex">
						<i class="iconfont icon-zhengcefagui2"></i>
						<div class="">政策法规</div>
					</div>
					<router-link class="index-main-top-more" to="/common/policy">更多<i class="el-icon-d-arrow-right"></i></router-link>
				</div>
				<div class="wrap-border">
					<empty v-if="!zcfg.length" :padding="'58px 0'" />
					<ul class="index-main-list" v-else>
						<li v-for="item in zcfg" :key="item.id">
							<router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/common/article/4/${item.id}`">
								<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
								<p>{{ item.publishtime }}</p>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="index-main-box">
				<div class="flex flex-row-between index-main-top">
					<div class="flex">
						<i class="iconfont icon-Z-fenleidaohang"></i>
						<div class="">诚信宣传</div>
					</div>
					<router-link class="index-main-top-more" to="/common/typical">更多<i class="el-icon-d-arrow-right"></i></router-link>
				</div>
				<div class="wrap-border">
					<empty v-if="!dxal.length" :padding="'58px 0'" />
					<ul class="index-main-list" v-else>
						<li v-for="item in dxal" :key="item.id">
							<router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/common/article/3/${item.id}`">
								<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
								<p>{{ item.publishtime }}</p>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
<!--			<div class="index-main-box">-->
<!--				<div class="flex flex-row-between index-main-top">-->
<!--					<div class="flex">-->
<!--						<i class="iconfont icon-Z-fenleidaohang"></i>-->
<!--						<div class="">联合奖惩</div>-->
<!--					</div>-->
<!--					<router-link class="index-main-top-more" to="/common/rewardsPunishments">更多<i class="el-icon-d-arrow-right"></i></router-link>-->
<!--				</div>-->
<!--				<div class="wrap-border">-->
<!--					<empty v-if="!lhjc.length" :padding="'58px 0'" />-->
<!--					<ul class="index-main-list" v-else>-->
<!--						<li v-for="item in lhjc" :key="item.id">-->
<!--							<router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/common/article/8/${item.id}`">-->
<!--								<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>-->
<!--								<p>{{ item.publishtime }}</p>-->
<!--							</router-link>-->
<!--						</li>-->
<!--					</ul>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="index-main-box">-->
<!--				<div class="flex flex-row-between index-main-top">-->
<!--					<div class="flex">-->
<!--						<i class="iconfont icon-shuju"></i>-->
<!--						<div class="">行政许可公示</div>-->
<!--					</div>-->
<!--					<router-link class="index-main-top-more" to="/common/bothPublic">更多<i class="el-icon-d-arrow-right"></i></router-link>-->
<!--				</div>-->
<!--				<div class="wrap-border">-->
<!--					<empty v-if="!xzxkgs.length" :padding="'58px 0'" />-->
<!--					<ul class="index-main-list" v-else>-->
<!--						<li v-for="(item, index) in xzxkgs" :key="index">-->
<!--							<router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/company?number=${item.number}&tab=行政许可${item.type == 2 ? '&name=' + item.name : ''}`">-->
<!--								<p class="ellipsis-1" :title="item.name">{{ item.name }}</p>-->
<!--								<p>{{ item.createTime | timeFilter }}</p>-->
<!--							</router-link>-->
<!--						</li>-->
<!--					</ul>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="index-main-box">-->
<!--				<div class="flex flex-row-between index-main-top">-->
<!--					<div class="flex">-->
<!--						<i class="iconfont icon-fenlei"></i>-->
<!--						<div class="">行政处罚公示</div>-->
<!--					</div>-->
<!--					<router-link class="index-main-top-more" to="/common/bothPublic?tab=行政处罚">更多<i class="el-icon-d-arrow-right"></i></router-link>-->
<!--				</div>-->
<!--				<div class="wrap-border">-->
<!--					<empty v-if="!xzcfgs.length" :padding="'58px 0'" />-->
<!--					<ul class="index-main-list" v-else>-->
<!--						<li v-for="(item, index) in xzcfgs" :key="index">-->
<!--							<router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/company?number=${item.number}&tab=行政处罚${item.type == 4 ? '&name=' + item.name : ''}`">-->
<!--								<p class="ellipsis-1" :title="item.name">{{ item.name }}</p>-->
<!--								<p>{{ item.createTime | timeFilter }}</p>-->
<!--							</router-link>-->
<!--						</li>-->
<!--					</ul>-->
<!--				</div>-->
<!--			</div>-->
		</div>

		<div class="index-link index-bottom-link flex flex-row-between">
			<router-link class="index-link-box" tag="a" v-for="item in BOTTOM" :key="item.id" :to="item.link">
				<img :src="item.image" :alt="item.title" srcset="" />
				<p>{{ item.title }}</p>
			</router-link>
		</div>

		<div class="flex flex-row-between index-main index-bottom">
			<!-- 通知公告 -->
			<div class="index-main-box">
<!--				<div class="flex flex-row-between index-main-top">-->
<!--					<div class="flex">-->
<!--						<i class="iconfont icon-tongzhi"></i>-->
<!--						<div class="">通知公告</div>-->
<!--					</div>-->
<!--					<router-link class="index-main-top-more" to="/common/notice">更多<i class="el-icon-d-arrow-right"></i></router-link>-->
<!--				</div>-->
<!--				<div class="wrap-border">-->
<!--					<empty v-if="!tzgg.length" :padding="'58px 0'" />-->
<!--					<ul class="index-main-list" v-else>-->
<!--						<li v-for="item in tzgg" :key="item.id">-->
<!--							<router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/common/article/9/${item.id}`">-->
<!--								<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>-->
<!--								<p>{{ item.publishtime }}</p>-->
<!--							</router-link>-->
<!--						</li>-->
<!--					</ul>-->
<!--				</div>-->
        <div class="flex flex-row-between index-main-top">
          <div class="flex">
            <i class="iconfont icon-tongzhi"></i>
            <div class="">联合奖惩</div>
          </div>
          <router-link class="index-main-top-more" to="/common/rewardsPunishments">更多<i class="el-icon-d-arrow-right"></i></router-link>
        </div>
        <div class="wrap-border">
          <empty v-if="!lhjc.length" :padding="'58px 0'" />
          <ul class="index-main-list" v-else>
            <li v-for="item in lhjc" :key="item.id">
              <router-link class="flex flex-row-between" tag="a" target="_blank" :to="`/common/article/8/${item.id}`">
                <p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
                <p>{{ item.publishtime }}</p>
              </router-link>
            </li>
          </ul>
        </div>
			</div>
			<!-- 数据共享统计 -->
			<div class="index-main-box">
				<div class="flex flex-row-between index-main-top">
					<div class="flex">
						<i class="iconfont icon-yanjing"></i>
						<div class="">数据共享统计</div>
					</div>
					<p class="index-main-top-more" @click="goMore">更多<i class="el-icon-d-arrow-right"></i></p>
				</div>
				<div class="wrap-border">
					<div class="flex index-scroll-top">
						<p class="ellipsis-1" style="width: 55%">单位名称</p>
						<p style="width: 20%">数据总量（条）</p>
						<p style="width: 25%">更新日期</p>
					</div>
					<empty v-if="!sjgxtj.length" :padding="'33px 0'" />
					<vue-seamless-scroll v-else class="index-scroll" :data="sjgxtj" :class-option="defaultOption">
						<ul class="index-scroll-list">
							<li class="flex" v-for="(item, index) in sjgxtj" :key="index">
								<p class="ellipsis-1" style="width: 55%" :title="item.fullName">{{ item.fullName }}</p>
								<p style="width: 20%">{{ item.totalCount || '-' }}</p>
								<p style="width: 25%">{{ item.updateTime || '-' }}</p>
							</li>
						</ul>
					</vue-seamless-scroll>
				</div>
			</div>
		</div>
		<!-- 底部牛皮癣 -->
		<div class="flex flex-row-between">
			<!-- <router-link class="fy-rank" tag="a" to="/antiDisease">
				<img src="../static/images/index/fy.png" alt="" />
			</router-link> -->
			<!-- <a href="/#/antiDisease" title="疫情防控红黑榜" target="_blank"> <span><img style="width:300px;height:120px;" border="0" align="center" src="../static/images/index/fy.png"></span></a> -->
			<a href="https://credit.shandong.gov.cn/snipet/1062.html" title="信用修复一件事" target="_blank"> <span><img style="width:300px;height:120px;" border="0" align="center" src="../static/images/index/2lyf4d512yjq_o.png"></span></a>
			<a href="https://credit.shandong.gov.cn/snipet/1023.html" title="中小企业融资综合信用服务平台网络" target="_blank"> <span><img style="width:300px;height:120px;" border="0" align="center" src="../static/images/index/3lmsmwkim1lyd_o.png"></span></a>
			<a href="https://credit.shandong.gov.cn/dqjwspdwjgyhb.html" title="" target="_blank"> <span><img style="width:300px;height:120px;" border="0" align="center" src="../static/images/index/16-14-37.png"></span></a>
			<a href="https://credit.shandong.gov.cn/zfwysxts.html" title="" target="_blank"> <span><img style="width:300px;height:120px;" border="0" align="center" src="../static/images/index/2llyyis0724ip_o.jpg"></span></a>
		</div>
		<dialog-statistics ref="dialogStatisticsRef" />
	</div>
</template>

<script>
import { TOP, BOTTOM } from '@/utils/viewIndex';
import { getIndex } from '@/api';
import BASE_URL from '@/api/base.js';
import vueSeamlessScroll from 'vue-seamless-scroll';

import empty from '@/components/empty';

import dialogStatistics from './dialog-statistics.vue';
export default {
	components: {
		vueSeamlessScroll,
		empty,
		dialogStatistics
	},
	data() {
		return {
			TOP,
			BOTTOM,
			topNav: '头条资讯',
			headlines: [], //头条动态
			xzxkgs: [],
			xzcfgs: [],
			xy_trends: [],
			tzgg: [],
			sjgxtj: [],
			lhjc: [],
			gn_trends: [],
			dxal: [],
			area_trends: [],
			zcfg: [],
			slide: [{ image: require('@/static/images/swiper.jpg'), name: '' }]
		};
	},
	created() {},
	mounted() {
		this.getIndexData();
	},
	methods: {
		topNavChange(name) {
			if (this.topNav !== name) {
				this.$set(this, 'topNav', name);
			}
		},

		getIndexData() {
			getIndex().then((res) => {
				const { banners, headlines, feicheng, domestic, dynamics, rewardPunishes, policies, typicals, notices, permits, punishes, shares } = res;
				this.$set(
					this,
					'slide',
					(banners || []).map((item) =>
						Object.assign({}, item, {
							image: BASE_URL + item.image
						})
					)
				);
				this.$set(this, 'headlines', headlines);
				this.$set(this, 'area_trends', feicheng);
				this.$set(this, 'gn_trends', domestic);
				this.$set(this, 'xy_trends', dynamics);
				this.$set(this, 'zcfg', policies);
				this.$set(this, 'dxal', typicals);
				this.$set(this, 'lhjc', rewardPunishes);
				this.$set(this, 'xzxkgs', permits);
				this.$set(this, 'xzcfgs', punishes);
				this.$set(this, 'tzgg', notices);
				this.$set(this, 'sjgxtj', shares);
			});
		},
		goMoreHandler() {
			this.$router.push({
				path: `/common/dynamics/${this.topNav === '肥城动态' ? '肥城动态' : '国内动态'}`
			});
		},
		goMore() {
			this.$refs['dialogStatisticsRef'].show(this.sjgxtj);
		}
	},
	computed: {
		currentTrends() {
			switch (this.topNav) {
				case '头条资讯':
					return this.headlines;
				case '肥城动态':
					return this.area_trends;
				case '国内动态':
					return this.gn_trends;
				default:
					return this.headlines;
			}
		},
		defaultOption() {
			return {
				step: 1, // 数值越大速度滚动越快
				limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		}
	},
	watch: {},
	filters: {
		sliceBrief(brief) {
			if (brief) {
				if (brief && brief.length > 75) {
					return brief.slice(0, 75) + '...';
				} else {
					return brief;
				}
			} else {
				return '';
			}
		},
		timeFilter(str) {
			if (str.length > 10) {
				return str.slice(0, 10);
			} else {
				return str;
			}
		}
	}
};
</script>
<style lang='scss'>
	$red: #d11d0f;

	.index-wrap {
		width: 1280px;
		margin: 0 auto;
		padding-top: 15px;

		.index-link {
			width: 100%;
			height: 120px;
			margin: 0 auto 20px;
		}

		.index-link {
			padding-top: 20px;
			& > .index-link-box {
				position: relative;
				width: calc(14.28% - 15px);
				height: 100%;
				box-sizing: border-box;
				overflow: hidden;
				& > img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					transition: all 0.2s linear;
				}
				& > p {
					width: 100%;
					position: absolute;
					left: 0;
					bottom: 0;
					text-align: center;
					line-height: 2;
					font-size: 14px;
					color: #fff;
					background: rgba(0, 0, 0, 0.4);
				}

				&:hover {
					& > img {
						transform: scale(1.2);
					}
				}
			}
		}

		.index-bottom-link {
			height: 128px;
			& > .index-link-box {
				flex-basis: 305px;
			}
		}

		.index-top-wrap {
			height: 365px;
			.el-image {
				width: 538px;
				height: 365px;
			}
			.el-carousel {
				width: 538px;
				height: 100%;
				.el-carousel__container {
					width: 100%;
					height: 100%;
					.el-carousel__item {
						width: 100%;
						height: 100%;
						& > img {
							width: 100%;
							height: 100%;
						}
						& > div {
							width: 100%;
							background: rgba(0, 0, 0, 0.4);
							position: absolute;
							left: 0;
							bottom: 0;
							line-height: 60px;
							& > h3 {
								width: 60%;
								text-align: left;
								font-weight: 700;
								color: #fff;
								text-indent: 1em;
							}
						}
					}
				}
				.el-carousel__indicators {
					left: 80%;
					bottom: 18px;
					width: 40%;
					display: flex;
					justify-content: flex-end;
					padding-right: 10px;
					.el-carousel__indicator {
						padding: 0;
						margin: 0 3px;
						.el-carousel__button {
							width: 15px;
							height: 15px;
							border-radius: 50%;
							background-color: #cbcbcb;
						}
						&.is-active {
							.el-carousel__button {
								background-color: $red;
							}
						}
					}
				}
			}
			& > .index-top {
				height: 100%;
				width: calc(100% - 538px - 20px);
				.index-top-nav {
					& > div {
						flex-basis: 32%;
						text-align: center;
						background-color: #f6f6f6;
						padding: 10px 0;
						font-size: 16px;
						font-weight: 700;
						color: #7f7d7d;
						cursor: pointer;
						&.active {
							background-color: $red;
							color: #fff;
						}
					}
				}
				.index-top-list {
					height: calc(100% - 44px - 20px);
					margin-top: 20px;
					padding: 10px 15px;
					animation: animate-margin-top 1s linear;
					position: relative;

					.index-top-more {
						position: absolute;
						top: 4px;
						right: 4px;
						font-size: 15px;
						color: #b3b3b3;
						cursor: pointer;
					}

					& > ul {
						& > li {
							& > .index-top-flex,
							& > .index-top-top {
								border-bottom: 1px dotted #ccc;
								display: block;
							}
							& > .index-top-top {
								& > p {
									&.ellipsis-1 {
										width: 100%;
										color: $red;
										font-size: 20px;
										padding: 10px 15px;
										text-align: center;
										font-weight: 600;
									}
									&:last-of-type {
										height: 56px;
										text-indent: 2em;
										padding-bottom: 5px;
										overflow: hidden;
										line-height: 25px;
										text-align: left;
										& > span {
											color: rgb(36, 120, 194);
										}
									}
								}
							}
							& > .index-top-flex {
								height: 45px;
								line-height: 45px;
								overflow: hidden;
								padding-left: 20px;
								position: relative;
								&::before {
									content: '';
									width: 3px;
									height: 3px;
									border-radius: 50%;
									background-color: #ccc;
									position: absolute;
									left: 8px;
									top: 50%;
								}
								&:hover {
									color: $red;
								}
								p {
									&:first-of-type {
										flex-basis: 70%;
										text-align: left;
									}
									&:last-of-type {
										flex-basis: 30%;
										text-align: right;
									}
								}
							}
						}
					}
				}
			}
		}

		.index-main {
			& > .index-main-box {
				flex-basis: 32%;
				margin-bottom: 20px;
				overflow: hidden;
				&:nth-child(3n-1) {
					margin: 0 2% 20px;
				}
				& > .index-main-top {
					height: 50px;
					& > .flex {
						color: $red;
						border-bottom: 2px solid $red;
						line-height: 50px;

						& > div {
							font-size: 15px;
							padding-left: 5px;
						}
						& > i {
							font-size: 18px;
							font-weight: bold;
						}
					}
					.index-main-top-more {
						font-size: 13px;
						cursor: pointer;
						color: #b3b3b3;
					}
				}
				& > .wrap-border {
					height: 300px;
					width: 100%;
					overflow: hidden;
					& > .index-main-list {
						padding: 0 10px;
						& > li {
							height: 50px;
							cursor: pointer;
							line-height: 50px;
							color: #212121;
							&:hover {
								color: $red;
							}
							p {
								&:first-of-type {
									flex-basis: 70%;
									text-align: left;
								}
								&:last-of-type {
									flex-basis: 30%;
									text-align: right;
								}
							}
						}
					}
					& > .index-scroll-top {
						height: 50px;
						background-color: $red;
						color: #fff;
						text-align: center;
					}
				}
			}
		}

		.index-bottom {
			padding-bottom: 20px;
			.index-main-box {
				flex-basis: 49%;
				margin: 0 !important;
			}
		}

		.topList-enter-active {
			animation: animate-margin-top 0.5s linear;
		}

		.index-scroll {
			width: 100%;
			height: 250px;
			overflow: hidden;
			& ul.index-scroll-list {
				width: 100%;
				& > li {
					width: 100%;
					&:nth-child(even) {
						background-color: #f9fafc;
					}
					& > p {
						text-align: center;
						font-size: 16px;
						color: #212121;
						line-height: 50px;
					}
				}
			}
		}

		.index-column-wrap {
			justify-content: space-between;
			margin: 0 0 20px;
			& > .fy-rank {
				width: 30%;
				height: 120px;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		@keyframes animate-margin-top {
			0% {
				opacity: 0;
				margin-top: 105px;
			}

			to {
				margin-top: 0;
				opacity: 1;
			}
		}
	}
</style>
